<script>
import HeaderView from '../../shared/views/HeaderView';
import MainMenuInstructorView from '../../shared/views/MainMenuInstructorView';
import ModuleInstructorAccountComponent from '../features/ModuleInstructorAccountComponent';
import ModalInstructorView from '../../../components/instructors/views/modals/ModalInstructorView';

export default {
  components: {
    'header-view': HeaderView,
    'main-menu-instructor-view': MainMenuInstructorView,
    'modal-instructor-view': ModalInstructorView,
  },
  extends: ModuleInstructorAccountComponent,
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<template>
  <div>
    <header-view />
    <main-menu-instructor-view />
    <!-- Body Start -->
    <div class="wrapper _bg4586">
      <div class="_216b01">
        <div class="container-fluid">
          <div class="row justify-content-md-center">
            <div class="col-md-10">
              <div class="section3125 rpt145">
                <div class="row">
                  <div class="col-lg-7">
                    <!-- <a href="#" class="_216b22">
                      <span><i class="uil uil-cog"></i></span>Setting
                    </a> -->
                    <div class="dp_dt150">
                      <div class="img148">
                        <img
                          :src="profileImageUrl"
                          alt=""
                        >
                      </div>
                      <div
                        v-if="session"
                        class="prfledt1"
                      >
                        <h2>
                          {{ session.user.firstName }}
                          {{ session.user.lastName }}
                        </h2>
                        <span>{{ session.user.email }}</span>
                      </div>
                    </div>
                    <ul class="_ttl120">
                      <li>
                        <div class="_ttl121">
                          <div class="_ttl122">
                            Estudiantes Activos
                          </div>
                          <div
                            v-if="session && session.instructor"
                            class="_ttl123"
                          >
                            {{ session.instructor.totalStudents }}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="_ttl121">
                          <div class="_ttl122">
                            Cursos
                          </div>
                          <div
                            v-if="session && session.instructor"
                            class="_ttl123"
                          >
                            {{ session.instructor.totalCourses }}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="_ttl121">
                          <div class="_ttl122">
                            Reseñas
                          </div>
                          <div
                            v-if="session && session.instructor"
                            class="_ttl123"
                          >
                            {{ session.instructor.totalReviews }}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="_ttl121">
                          <div class="_ttl122">
                            Notificaciones
                          </div>
                          <div
                            v-if="session && session.instructor"
                            class="_ttl123"
                          >
                            {{ session.instructor.totalNotifications }}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="col-lg-5">
                    <!-- <a href="setting.html" class="_216b12">
                      <span><i class="uil uil-cog"></i></span>Setting
                    </a> -->
                    <div class="rgt-145">
                      <ul
                        v-if="session && session.instructor"
                        class="tutor_social_links"
                      >
                        <li v-if="session.instructor.pageUrlFacebook">
                          <a
                            :href="session.instructor.pageUrlFacebook"
                            target="_blank"
                            class="fb"
                          ><i class="fab fa-facebook-f" /></a>
                        </li>
                        <li v-if="session.instructor.pageUrlInstagram">
                          <a
                            :href="session.instructor.pageUrlInstagram"
                            target="_blank"
                            class="in"
                          ><i class="fab fa-instagram" /></a>
                        </li>
                        <li v-if="session.instructor.pageUrlLinkedIn">
                          <a
                            :href="session.instructor.pageUrlLinkedIn"
                            target="_blank"
                            class="ln"
                          ><i class="fab fa-linkedin-in" /></a>
                        </li>
                      </ul>
                    </div>
                    <ul class="_bty149">
                      <li>
                        <el-button
                          type="primary"
                          class="studio-link-btn"
                          @click="onEditProfile"
                        >
                          Editar
                        </el-button>
                      </li>
                      <!-- <li>
                        <button
                          class="msg125 btn500"
                          onclick="window.location.href = 'setting.html';"
                        >
                          Edit
                        </button>
                      </li> -->
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="_215b15">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="course_tabs">
                <nav>
                  <div
                    id="nav-tab"
                    class="nav nav-tabs tab_crse"
                    role="tablist"
                  >
                    <a
                      id="nav-about-tab"
                      class="nav-item nav-link active"
                      data-toggle="tab"
                      href="#nav-about"
                      role="tab"
                      aria-selected="true"
                    >Acerca</a>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="_215b17">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <div class="course_tab_content">
                <div
                  id="nav-tabContent"
                  class="tab-content"
                >
                  <div
                    id="nav-about"
                    class="tab-pane fade show active"
                    role="tabpanel"
                  >
                    <div class="_htg451">
                      <div class="container">
                        <h3>Acerca de mi</h3>
                        <p>
                          {{ sessionAbout }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Body End -->
    <modal-instructor-view
      v-if="modalItem.isVisible"
      :form-data="item"
      :conf="modalItem"
      :show-status="false"
    />
    <div v-loading.fullscreen.lock="fullLoader" />
  </div>
</template>
